export enum SystemOfMeasuresEnum {
  imperial = 'imperial',
  si = 'si',
  si_cl = 'si_cl',
}
